module.exports = __webpack_public_path__ + "img/france.bbe1ce6d.svg";